import type { MonetaryAmount } from "../../../../../currency/currencyTypes"

export type SubscriptionKitchen = Readonly<{
    name: string
    kitchenType?: string
}>

export type LunchSubscription = Readonly<{
    id: number
    subscriptionName: string
    pricePerMonth?: MonetaryAmount
}>

export enum SubscriptionUsagePeriod {
    WEEK = "WEEK",
    MONTH = "MONTH",
}

export type SubscriptionUsageDetails = Readonly<{
    usagePeriod: SubscriptionUsagePeriod | string
    limit: number
    used: number
    remaining: number
}>

export type OrderedLunchSubscriptionDetails = Readonly<{
    subscriptionStatus: string
    subscriptionStatusAsText?: string
    unsubscribeStatusAsText?: string
    subscriptionDate?: string
    unsubscribeDate?: string
    kitchens: SubscriptionKitchen[]
    lunchSubscription: LunchSubscription
    usageDetails?: SubscriptionUsageDetails
}>

export type OrderedLunchSubscription = Readonly<{
    id: number
    subscriptionDetails: OrderedLunchSubscriptionDetails
}>

export type MyLunchSubscriptionsResponse = Readonly<{
    orders: OrderedLunchSubscription[]
}>
